module.exports = __webpack_public_path__ + "media/images/tigor/tigor-ad21aff1f0116e16d473bde27010a413.png";